import { hideModal } from "../../../context/Actions/modal/modal";
import "./ModalGrupoFamiliar.css";
import { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  deleteVinculo,
  limpiarDeleteFamiliar,
  wsGetGrupoFamiliar,
  wsPutVinculo,
} from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { IonSpinner } from "@ionic/react";
import { getListaFamiliares } from "_+_Portal/context/Actions/listaFamiliares/listasFamiliares";
// Este es el modal para desvincular
const ModalGrupoFamiliar = ({ nombre, idpaciente2, type, idFamiliar }) => {
  // nombre hace referencia al nombre del familiar
  const { toasterDispatch } = useContext(GlobalContext);
  const { modalDispatch, grupoFamiliarDispatch, listaFamiliaresDispatch } =
    useContext(PortalContext);
  const [loadingBtn, setLoadingBtn] = useState(false);

  // cierra el modal
  const handleClickModal = () => {
    hideModal()(modalDispatch);
    // deleteVinculo(idpaciente1,idpaciente2)()
  };

  const handleClickDelete = () => {
    setLoadingBtn(true);
    if (type === "PUT") {
      wsPutVinculo(
        {
          idParentescoProcesa: 3,
        },
        idFamiliar,
        (isCorrect, data) => {
          if (isCorrect) {
            showToaster(
              {
                texto: "El familiar fue desvinculado correctamente",
                tipo: "success",
              },
              "centroArriba"
            )(toasterDispatch);
            wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
            getListaFamiliares(true)(listaFamiliaresDispatch);
            hideModal()(modalDispatch);
          } else {
            showToaster(
              {
                texto:
                  data && typeof data === "string"
                    ? data
                    : "Error al desvincular familiar",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
          }
          limpiarDeleteFamiliar()(grupoFamiliarDispatch);
          setLoadingBtn(false);
        }
      )(grupoFamiliarDispatch);
    } else {
      deleteVinculo(idpaciente2, (isCorrect, data) => {
        if (isCorrect) {
          showToaster(
            {
              texto: "El familiar fue desvinculado correctamente",
              tipo: "success",
            },
            "centroArriba"
          )(toasterDispatch);
          wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
          getListaFamiliares(true)(listaFamiliaresDispatch);
          hideModal()(modalDispatch);
        } else {
          showToaster(
            {
              texto: "Error al desvincular el familiar",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        }
        limpiarDeleteFamiliar()(grupoFamiliarDispatch);
        setLoadingBtn(false);
      })(grupoFamiliarDispatch);
    }
  };

  return (
    <div className="ptur-modalGrupoFamiliar-container">
      <div className="ptur-modalGrupoFamiliar-header bgcG-danger">
        <span className="ptur-modalGrupoFamiliar-header-title">
          Desea desvincular familiar ?
        </span>
        <span
          className="ptur-modalGrupoFamiliar-header-cruz"
          onClick={handleClickModal}
        >
          X
        </span>
      </div>
      <div className="ptur-modalGrupoFamiliar-body">
        <span className="ptur-modalGrupoFamiliar-body-text">
          Desea eliminar la vinculación familiar con:{" "}
          <span className="rb18m">{nombre} ?</span>
        </span>
        <div className="ptur-modalGrupoFamiliar-body-btnContainer">
          <button
            className="ptur-modalGrupoFamiliar-body-btn-disable"
            onClick={handleClickModal}
          >
            No, cancelar
          </button>
          <button
            className="ptur-modalGrupoFamiliar-body-btn-red bgcG-danger"
            onClick={loadingBtn ? () => {} : handleClickDelete}
          >
            {loadingBtn ? <IonSpinner name="lines" /> : "Si, desvincular"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalGrupoFamiliar;
